exports = module.exports = require("../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\n/*\n * Hiding the browser's native password reveal control when showing our own toggle.\n * Avoids duplicate eye icons in Microsoft Edge (and IE), which only show their\n * reveal button when the field is focused and has content.\n */\n[data-v-91c2358c] input[type='password']::-ms-reveal {\n  display: none;\n}\n", ""]);

